import { Component } from '@angular/core';
import { MotifButtonModule } from '@ey-xd/ng-motif';
import { Observable, tap } from 'rxjs';
import { AuthenticationService } from '../core/service/auth/authentication.service';
import { Router } from '@angular/router';
import { AsyncPipe, CommonModule } from '@angular/common';
import { BreakpointObserver } from '@angular/cdk/layout';

@Component({
  selector: 'app-login',
  standalone: true,
  imports: [CommonModule, MotifButtonModule, AsyncPipe],
  templateUrl: './login.component.html',
  styleUrl: './login.component.scss',
})
export class LoginComponent {
  loggedIn$: Observable<boolean>;

  // Zoom related properties for breakpoint observer
  isZoomed: boolean = false;

  constructor(
    private authenticationService: AuthenticationService,
    private router: Router,
    private breakpointObserver: BreakpointObserver
  ) {
    this.breakpointObserver
      .observe(['(max-width: 800px)'])
      .subscribe((result) => {
        this.isZoomed = result.matches;
      });

    this.loggedIn$ = this.authenticationService.isLoggedIn().pipe(
      tap((loggedIn) => {
        switch (loggedIn) {
          case true:
            this.authenticationService.initializeTokenManagement();
            return this.router.navigate(['home']);
          case false:
            console.log('login', false);
            return false;
          case null:
            console.log('login', null);
            return false;
        }
      })
    );
  }

  onClickLogin(): void {
    this.authenticationService.login();
  }
}
